var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46422 25.0921C1.39777 24.0257 1.72943 22.4275 3.45564 20.3012L3.57669 20.1801C5.30179 18.455 17.8225 6.6784 23.3394 2.64949C24.2106 2.22811 24.9428 2.31592 25.5364 2.9095L26.545 3.91807C26.2414 5.40548 25.4139 6.82823 24.068 8.17412C16.8117 14.7293 3.82332 26.4512 2.90898 25.5369L2.46422 25.0921Z",
    fill: "#F03B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0914 3.54395C24.0608 2.38861 25.6818 2.57972 27.9505 4.11404L28.0817 4.22408C29.9506 5.79226 42.7736 17.2389 47.2681 22.3837C47.7637 23.2148 47.7401 23.9519 47.2005 24.595L46.2837 25.6876C44.7755 25.5149 43.286 24.8145 41.8279 23.591C34.6653 16.9337 21.8559 5.01633 22.6871 4.02579L23.0914 3.54395Z",
    fill: "#F03B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0063 19.6542C11.7136 19.5295 12.8428 20.5559 13.3937 22.7334L13.4081 22.8717C13.6149 24.8449 14.2606 36.7353 13.6409 42.2758C13.3583 43.0405 12.7404 43.4567 11.7901 43.5261L10.1754 43.644C9.12036 42.6881 8.50941 41.4393 8.34828 39.9015C8.08248 31.968 7.83047 19.8131 9.29427 19.7062L10.0063 19.6542Z",
    fill: "#F03B38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0063 19.6542C38.7136 19.5295 39.8428 20.5559 40.3937 22.7334L40.4081 22.8717C40.6149 24.8449 41.2606 36.7353 40.6409 42.2758C40.3583 43.0405 39.7404 43.4567 38.7901 43.5261L37.1754 43.644C36.1204 42.6881 35.5094 41.4393 35.3483 39.9015C35.0825 31.968 34.8305 19.8131 36.2943 19.7062L37.0063 19.6542Z",
    fill: "#F03B38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25586 41.2501C8.25586 39.7945 9.65226 39.0679 12.45 39.0679C19.9156 39.4887 34.1971 39.7002 35.4546 39.7002H35.6282C37.0742 39.7002 38.0762 39.5968 38.6442 39.3852C40.2018 39.6244 40.9831 40.2981 40.9831 41.4065V42.8C40.9831 43.9475 27.1531 44.5224 19.3253 44.5224C12.0581 44.5224 8.42452 43.8486 8.42452 42.4965L8.25586 41.4065V41.2501Z",
    fill: "#F03B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHome);
export default __webpack_public_path__ + "static/media/footer-home.448a5b5f23ef4530326e357550726759.svg";
export { ForwardRef as ReactComponent };